module.exports = __webpack_public_path__ + "41c0c1a61f2f46d0fcc26c73dc4c98ed.png";